import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserNotificationService {
  private permission: NotificationPermission = 'default';

  constructor() {
    this.checkPermission();
  }

  private checkPermission(): void {
    if ('Notification' in window) {
      this.permission = Notification.permission;
    }
  }

  async requestPermission(): Promise<boolean> {
    if (!('Notification' in window)) {
      console.warn('Este navegador no soporta notificaciones');
      return false;
    }

    if (this.permission === 'granted') {
      return true;
    }

    const permission = await Notification.requestPermission();
    this.permission = permission;
    return permission === 'granted';
  }

  showNotification(title: string, options?: NotificationOptions): void {
    if (this.permission !== 'granted') {
      console.warn('Permisos de notificación no concedidos');
      return;
    }

    const notification = new Notification(title, {
      requireInteraction: true,
      ...options
    });

    // Auto-close after 10 seconds if not interacted
    setTimeout(() => {
      notification.close();
    }, 10000);
  }

  showPanicAlert(guardName: string, facilityName: string): void {
    this.showNotification('🚨 ALERTA DE PÁNICO', {
      body: `${guardName} en ${facilityName}`,
      tag: 'panic-alert',
      requireInteraction: true,
      silent: false
    });
  }
}